import React, { useEffect, useState } from 'react'
import Image from 'next/image'
const Thankyou = ({ counter3 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      counter3();
    }, 3000);
    return () => clearTimeout(timer);
  }, [counter3]);

  return (
    <>
      <div id="thankyou-leadgen" className={`bg-gray-50 rounded-lg p-6 mdb:p-10 duration-700 transition-all ease-in-out  ${isVisible ? "scale-100 opacity-100" : "scale-50 opacity-0"}  mdb:!w-[34vw] border-2  border-black-500 z-10 relative`} style={{ boxShadow: '10px 10px 0px rgba(0, 0, 0, 1)' }}>
        <div className='flex flex-col justify-center items-center'>
          <h1 className="text-2xl font-bold  bg-gradient-to-r from-blue-500 to-teal-500 mb-6 text-transparent bg-clip-text">Thank you for filling the form!</h1>
          <Image src="/Assets/Succeess Animation.png" alt="success" height={250} width={250} />
          <p className=" mt-4 border-2 border-dashed border-blue-400 p-1 rounded-lg text-lg bg-gradient-to-r from-blue-500 to-teal-500 mb-6 text-transparent bg-clip-text">We will contact you shortly.</p>
        </div>
      </div>

    </>
  )
}

export default Thankyou
